import React, { useEffect, useState } from "react";
import Footer from "../../../Kryzen Alpha App/Components/Footer/footer";
import StepRoutes from "../../../Kryzen Alpha App/Routes/steps_routes";
import { useParams } from "react-router-dom";
import LoadingPage from "../../../Kryzen Alpha App/Components/layouts/loading";
import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import performRequest from "../../../Kryzen Alpha App/api/request";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { FcAcceptDatabase, FcAdvance, FcPhone, FcStackOfPhotos } from "react-icons/fc";
import SimpleButton from "../../Components/layouts/simple_button";
import { extractDate } from "../../Components/Functions/date.fun";

const ViewTransferDetails = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  let { id } = useParams();


  // ==========================================
  // GET CALL DETAILS
  // ==========================================

  useEffect(() => {
    setLoading(true);

    performRequest("GET", `/leads_v2/leadsTransfers/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data);
        } else {
          Toast("error", "Error while fetching lead details");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  // ==========================================
  // LOADING
  // ==========================================

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          {/* HEADER */}

          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcAdvance className="fs-2 me-1" />
                  View Lead Transfer Details
                </h2>

                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>

          {/* MAIN CARD */}

          <div className="card my-4">
            {/* CARD HEADER */}

            <div className="card-header d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <h2 className="page-title">View Lead Transfer Details</h2>
              </div>
            </div>

            {/* CARD BODY */}

            <div className="card-body">
              {/* CUSTOMER NAME */}

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">Lead Name :</label>

                <div className="w-100 col">
                  {data?.lead?.full_name || "N/A"}
                </div>
              </div>

              {/* PHONE NUMBER */}

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">
                  Lead Number :
                </label>

                <div className="w-100 col">
                  {data?.lead?.contact_number ||
                    data?.lead?.whatsapp_number ||
                    "N/A"}
                </div>
              </div>

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">
                  Transfer Owner Name :
                </label>

                <div className="w-100 col">{data?.fromOwenerName || "N/A"}</div>
              </div>

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">
                  {" "}
                  Recived Transfer Name :
                </label>

                <div className="w-100 col">{data?.toOwnerName || "N/A"}</div>
              </div>

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">
                  {" "}
                  Transfer Reson:
                </label>

                <div className="w-100 col">{data?.reason || "N/A"}</div>
              </div>

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">Created At:</label>

                <div className="w-100 col">
                  {data?.createdAt?.split("T")[0] || "N/A"}
                </div>
              </div>
              <div className="mb-2 mt-4">
                <hr className="m-0 p-0"></hr>
                <div>
                  <h2 className="page-title mt-2 mb-2">Follow Up</h2>
                </div>

                <div className="table-responsive">
                  <table className="table table-bordered table-hover table-striped">
                    <thead className="table-light">
                      <tr>
                        <th>Sr</th>
                        <th>Created Date</th>
                        <th>Follow Up Date</th>
                        <th>Created By</th>
                        <th>Follow Up</th>
                      </tr>
                    </thead>

                    <tbody>
                      {data?.lead?.followUp?.length > 0 ? (
                        data?.lead?.followUp?.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item?.createdAt || "-"}</td>
                            <td>{item?.followUpDate || "-"}</td>
                            <td>{item?.createdBy || "-"}</td>
                            <td
                              style={{
                                maxWidth: "350px",
                                whiteSpace: "normal",
                              }}
                            >
                              {item?.followUp}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No Follow Up Available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewTransferDetails;
